import { Box, Button, Typography } from "@mui/material";
import { memo } from "react";
import { icon } from "@/app/style/icons";

interface ErrorScreenProps {
    error?: Error;
    message?: string;
    onRetry?: () => void;
}

const ErrorScreen = memo(({ error, message = "Something went wrong", onRetry }: ErrorScreenProps) => {
    const handleRefresh = () => {
        if (onRetry) {
            onRetry();
        } else {
            window.location.reload();
        }
    };

    return (
        <Box
            sx={{
                height: "100vh",
                width: "100vw",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "semantic.surface.primary",
                p: 3,
            }}
        >
            <icon.error
                sx={{
                    fontSize: 64,
                    color: "semantic.notification.error",
                    mb: 3,
                }}
            />

            <Typography
                variant="h5"
                sx={{
                    fontWeight: 500,
                    textAlign: "center",
                    mb: 2,
                }}
            >
                {message}
            </Typography>

            {error && (
                <Typography
                    variant="body2"
                    sx={{
                        textAlign: "center",
                        mb: 4,
                        maxWidth: "600px",
                    }}
                >
                    {error.message}
                </Typography>
            )}

            <Button variant="contained" onClick={handleRefresh} startIcon={<icon.refresh />}>
                Try Again
            </Button>
        </Box>
    );
});

export default ErrorScreen;
